// import fetch from 'node-fetch';
import { Tokens } from '@fasstech/oip-starter-utils/app';
import { compose, find, isNil, map, prop, propEq, propOr, reject } from 'ramda';
import { isNilOrEmpty } from '@@serverHelpers/index.mjs';

export const onUploadFile = async (files, _fileType, _name, formData, append) => {

  const accessToken = await Tokens.getAccessToken();
  try {
    const fetchOptions = {
      method: 'POST',
      body: formData,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };
    const response = await fetch('/upload/files', fetchOptions);
    const jsonResponse = await response.json();
    if (propEq('status', 200, response)) {
      const uniqFiles = compose(
        reject(isNil),
        map((file) => {
          if (isNilOrEmpty(find(propEq('fileName', prop('fileName', file)))(files))) return file;
        }),
        propOr([], 'files')
      )(jsonResponse);
      map((file) => append(file))(uniqFiles);
      return {
        ok: true,
        data: uniqFiles
      };
    } else {
      if (jsonResponse.error) {
        console.log('[onUploadFile] Upload failed:', jsonResponse.error);
      }
      return {
        ok: false,
        error: jsonResponse.error
      };
    }
  } catch (err) {
    console.error('[onUploadFile] Fetch error:', err);
    return {
      ok: false,
      error: err?.message || err
    };
  }
};
